// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n    .pwd-help {\n      margin: 1rem 0;\n      border-radius: 20px;\n      font-size: 0.9rem;\n      width: 100%;\n      color: #995C00;\n      background-color: #FEEFB3;\n      padding: 0.5rem 0.8rem;\n    }\n  ", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
